














import { Component, Vue } from 'vue-property-decorator';
import { timeFormat } from '@/utils/other';

const columns = [
  {
    slots: { title: 'checkInTitle' },
    dataIndex: 'checkIn',
    scopedSlots: { customRender: 'checkIn' },
    width: '50%',
  },
  {
    slots: { title: 'checkOutTitle' },
    dataIndex: 'checkOut',
    scopedSlots: { customRender: 'checkOut' },
    width: '50%',
  },
];

@Component({
  filters: {
    timeFormat,
  },
})
export default class RecordsModal extends Vue {
  private columns = columns;
  private visible = false;
  private records: ITodo.IResponse.IRecordInfo[] = [];
  public showVisible(records: ITodo.IResponse.IRecordInfo[]) {
    this.visible = true;
    this.records = records;
  }
  private onClose() {
    this.visible = false;
    this.records = [];
  }
}
